import { Register } from "modules/RegisterModule";
import { FC } from "react";


interface RegisterPageProps {}

const RegisterPage: FC<RegisterPageProps> = () => {
  return (
    <div className="w-full h-screen">
      <Register />
    </div>
  );
};

export default RegisterPage;
